import { render } from "./ModalPopup.vue?vue&type=template&id=128b42b4&scoped=true"
import script from "./ModalPopup.vue?vue&type=script&lang=js"
export * from "./ModalPopup.vue?vue&type=script&lang=js"

import "./ModalPopup.vue?vue&type=style&index=0&id=128b42b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128b42b4"]])

export default __exports__